import React from 'react';
import EcoTitle from 'eco-design/base/eco-title';
import EcoImg from 'eco-design/base/eco-img';
import { useProductStore } from '../../../../ProductProvider';
import { useWebpOrJpg } from '../../hooks/useWebpOrJpg';
import css from './index.module.scss';
import { useLang } from '@/i18n';

const OnePicture: React.FC = ({}) => {
    const { t } = useLang('theProductV2.OnePicture');
    const { pageStatus } = useProductStore();
    const webpOrJpg = useWebpOrJpg('#rapid-mag-OnePicture-V2');

    const cards = [
        {
            label: t('item1_label'),
            title: t('item1_title'),
            desc: t('item1_desc'),

            jpg: ['https://websiteoss.ecoflow.com/upload/image/1762502897844/1.png', 'https://websiteoss.ecoflow.com/upload/image/1761293481285/grid-1-h5.png'],
            webp: [
                'https://websiteoss.ecoflow.com/upload/image/1762502898504/1.webp',
                'https://websiteoss.ecoflow.com/upload/image/1761293751267/grid-1-h5.png',
            ],
        },
        {
            title: t('item2_title'),
            jpg: [
                'https://websiteoss.ecoflow.com/upload/image/1762482007774/grid-2.png',
                'https://websiteoss.ecoflow.com/upload/image/1762482007247/grid-2-h5.png',
            ],
            webp: [
                'https://websiteoss.ecoflow.com/upload/image/1762482074938/grid-2.webp',
                'https://websiteoss.ecoflow.com/upload/image/1762482074705/grid-2-h5.webp',
            ],
        },
        {
            title: t('item3_title'),
            desc: t('item3_desc'),
            jpg: [
                'https://websiteoss.ecoflow.com/upload/image/1761293441648/grid-3.png',
                'https://websiteoss.ecoflow.com/upload/image/1761293481748/grid-3-h5.png',
            ],
            webp: [
                'https://websiteoss.ecoflow.com/upload/image/1761293703873/grid-3.webp',
                'https://websiteoss.ecoflow.com/upload/image/1761293777552/grid-3-h5.png',
            ],
        },
        {
            title: t('item4_title'),
            jpg: ['https://websiteoss.ecoflow.com/upload/image/1762502898101/4.png', 'https://websiteoss.ecoflow.com/upload/image/1762482010154/grid-4-h5.png'],
            webp: [
                'https://websiteoss.ecoflow.com/upload/image/1762502898976/4.webp',
                'https://websiteoss.ecoflow.com/upload/image/1762482076414/grid-4-h5.webp',
            ],
        },
        {
            title: t.rich('item5_title', {
                b: (v: string) => <span className="blod">{v}</span>,
            }),
            jpg: [
                'https://websiteoss.ecoflow.com/upload/image/1761293442736/grid-5.png',
                'https://websiteoss.ecoflow.com/upload/image/1761293482145/grid-5-h5.png',
            ],
            webp: [
                'https://websiteoss.ecoflow.com/upload/image/1761293704449/grid-5.webp',
                'https://websiteoss.ecoflow.com/upload/image/1761293808601/grid-5-h5.png',
            ],
        },
        {
            label: t('item6_label'),
            title: t('item6_title'),
            icon: webpOrJpg(
                'https://websiteoss.ecoflow.com/upload/image/1761297417173/card-icon.png',
                'https://websiteoss.ecoflow.com/upload/image/1761707444504/card-icon.webp',
            ),
            jpg: [
                'https://websiteoss.ecoflow.com/upload/image/1762482008280/grid-6.png',
                'https://websiteoss.ecoflow.com/upload/image/1762482009102/grid-6-h5.png',
            ],
            webp: [
                'https://websiteoss.ecoflow.com/upload/image/1762482075957/grid-6.webp',
                'https://websiteoss.ecoflow.com/upload/image/1762482075517/grid-6-h5.webp',
            ],
        },
    ];

    return (
        <section
            className={`${css.section} rapid-mag-OnePicture-V2 GtmModuleData-section`}
            id="rapid-mag-OnePicture-V2"
            data-section-id={'rapid-mag-OnePicture-V2'}
            data-section-title={t('title')}
        >
            <EcoTitle title={t('title')} />
            <div className="onePicture-content">
                {!['statusC'].includes(pageStatus) && (
                    <div className="head-card">
                        <div className="head-info">
                            <div className="head-title">{t('head_title')}</div>
                            <div className="head-desc">{t('head_desc')}</div>
                        </div>
                        <EcoImg
                            pc={webpOrJpg(
                                'https://websiteoss.ecoflow.com/upload/image/1762498946818/head-pc.png',
                                'https://websiteoss.ecoflow.com/upload/image/1762498946635/head-pc.webp',
                            )}
                            pad={webpOrJpg(
                                'https://websiteoss.ecoflow.com/upload/image/1762498946818/head-pc.png',
                                'https://websiteoss.ecoflow.com/upload/image/1762498946635/head-pc.webp',
                            )}
                            h5={webpOrJpg(
                                'https://websiteoss.ecoflow.com/upload/image/1762498945755/head-m.png',
                                'https://websiteoss.ecoflow.com/upload/image/1762498946022/head-m.webp',
                            )}
                        />
                    </div>
                )}
                <div className="one-pricture-grid">
                    {cards.map((i, idx) => (
                        <div className={`grid-item grid-item-${idx + 1}`} key={idx}>
                            <EcoImg pc={webpOrJpg(i.jpg[0], i.webp[0])} pad={webpOrJpg(i.jpg[0], i.webp[0])} h5={webpOrJpg(i.jpg[1], i.webp[1])} />
                            {i.label && <div className="grid-label">{i.label}</div>}
                            {i.title && <div className="grid-title">{i.title}</div>}
                            {i.desc && <div className="grid-desc">{i.desc}</div>}
                            {i.icon && (
                                <div className="grid-icon">
                                    <img src={webpOrJpg(i.icon)} alt="" />
                                </div>
                            )}
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};
export default OnePicture;
